import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { NotificationListItem } from '@/models/Notification';
import NotificationPanelItem from '@/components/toolbar/notification/NotificationPanelItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPanelItems',
  props: {
  items: {
    type: Array as PropType<NotificationListItem[]>,
    default: () => []
  }
},
  setup(__props) {



return { __sfc: true,NotificationPanelItem }
}

})